import Review from './ComposedReview';
import { ReviewQuery } from './ReviewQuery.graphql';

Review.query = ReviewQuery;

export default Review;
